module.exports = __webpack_public_path__ + "img/responsible-citizen.c41d9e6a.png";